import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { IconVideo } from '@calendly/ui/components/glyphs/IconVideo';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import React from 'react';
import { useMeetingTracking } from 'features/meetings/hooks';
import type { Meeting } from 'features/meetings/types';
import { getEventLocationIfURL } from 'features/meetings/utils';
const noop = (_hovered: boolean) => {};
const fullWidthMobileCss = "fjmb5xa";
interface JoinButtonProps {
  event: Meeting;
  hasRealtimeFeatures?: boolean;
  isMostRecentInProgress?: boolean;
  setHovered?: (hovered: boolean) => void;
}

/**
 * Renders a button that opens the meeting's video call URL in a new tab.
 *
 * Returns `null` if the meeting's location is not a valid URL. The button
 * style is `primary` by default, but switches to `outline` when realtime
 * features are active and the meeting is not the most recent in-progress event.
 *
 * @param event - The meeting whose video location URL is used
 * @param hasRealtimeFeatures - Whether the realtime feature flag is enabled
 * @param isMostRecentInProgress - Whether this is the most recent in-progress meeting in the list
 * @param setHovered - Callback invoked with hover state changes, used to highlight the parent card
 */
export const JoinButton = ({
  event,
  hasRealtimeFeatures = false,
  isMostRecentInProgress = false,
  setHovered = noop
}: JoinButtonProps) => {
  const {
    trackJoin
  } = useMeetingTracking(event);
  const eventLocation = getEventLocationIfURL(event.location);
  if (!eventLocation) return null;
  const onJoinClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    trackJoin();
    window.open(eventLocation, '_blank', 'noopener,noreferrer');
  };
  const decoration = hasRealtimeFeatures && !isMostRecentInProgress ? 'outline' : 'primary';
  return <Button className={fullWidthMobileCss} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} onClick={onJoinClick} size="small" decoration={decoration} responsive={false}>
      <UiIcon icon={IconVideo} size="small" />
      {I18n.t('publisher.meetings.actions.join_meeting')}
    </Button>;
};

require("./JoinButton.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./JoinButton.tsx");